function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Conviva } from '@sky-uk-ott/core-video-sdk-js-external-conviva';
import { InternalSessionState } from '../../../core/session-controller/internal-session-state';
// Workaround to trigger seek state so that buffering as a result of audio track changes doesn't count towards CIRR
// (Connection Induced Rebuffering Ratio)
export var AudioTrackChangeWorkaround = /*#__PURE__*/ function() {
    "use strict";
    function AudioTrackChangeWorkaround(session) {
        var convivaAdInsights = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, convivaVideoAnalytics = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, logger = arguments.length > 3 ? arguments[3] : void 0, onReportSeekEnded = arguments.length > 4 ? arguments[4] : void 0, onReportPlayerState = arguments.length > 5 ? arguments[5] : void 0;
        _class_call_check(this, AudioTrackChangeWorkaround);
        _define_property(this, "session", void 0);
        _define_property(this, "convivaAdInsights", void 0);
        _define_property(this, "convivaVideoAnalytics", void 0);
        _define_property(this, "audioTrackChangeWorkaroundTimeoutId", void 0);
        _define_property(this, "isAudioTrackChanging", void 0);
        _define_property(this, "isAudioTrackBuffering", void 0);
        _define_property(this, "reportSeekEnded", void 0);
        _define_property(this, "reportPlayerState", void 0);
        _define_property(this, "logger", void 0);
        this.session = session;
        this.convivaAdInsights = convivaAdInsights;
        this.convivaVideoAnalytics = convivaVideoAnalytics;
        this.audioTrackChangeWorkaroundTimeoutId = null;
        this.isAudioTrackChanging = false;
        this.isAudioTrackBuffering = false;
        this.logger = logger;
        this.logger.verbose('Audio track change workaround in place');
        this.reportSeekEnded = onReportSeekEnded;
        this.reportPlayerState = onReportPlayerState;
        this.listenToPlayerEvents();
    }
    _create_class(AudioTrackChangeWorkaround, [
        {
            key: "destroy",
            value: function destroy() {
                if (this.audioTrackChangeWorkaroundTimeoutId) {
                    clearTimeout(this.audioTrackChangeWorkaroundTimeoutId);
                    this.audioTrackChangeWorkaroundTimeoutId = null;
                }
            }
        },
        {
            key: "isChanging",
            value: function isChanging() {
                return this.isAudioTrackChanging;
            }
        },
        {
            key: "handleStateChangesDueToAudioTrackChange",
            value: function handleStateChangesDueToAudioTrackChange(state) {
                if (!this.isAudioTrackChanging) return false;
                if (state === InternalSessionState.Rebuffering && this.audioTrackChangeWorkaroundTimeoutId) {
                    clearTimeout(this.audioTrackChangeWorkaroundTimeoutId);
                    this.audioTrackChangeWorkaroundTimeoutId = null;
                    if (!this.isAudioTrackBuffering) {
                        // Seek Start should be before Rebuffering report
                        this.reportSeekStartedForAudioTrackChangeWorkaround();
                        this.reportPlayerState(state);
                        this.isAudioTrackBuffering = true;
                        return true;
                    }
                }
                if ([
                    InternalSessionState.Playing,
                    InternalSessionState.Paused
                ].includes(state)) {
                    this.isAudioTrackChanging = false;
                    if (this.isAudioTrackBuffering) {
                        // Seek End should be after Playing/Paused report
                        this.reportPlayerState(state);
                        this.reportSeekEnded();
                        this.isAudioTrackBuffering = false;
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "reportSeekStartedForAudioTrackChangeWorkaround",
            value: function reportSeekStartedForAudioTrackChangeWorkaround() {
                var _this_convivaAdInsights;
                this.convivaVideoAnalytics.reportPlaybackMetric(Conviva.Constants.Playback.SEEK_STARTED);
                (_this_convivaAdInsights = this.convivaAdInsights) === null || _this_convivaAdInsights === void 0 ? void 0 : _this_convivaAdInsights.reportSeekStartedWorkaround();
                this.logger.verbose('Report seek started for audio track change workaround');
            }
        },
        {
            key: "listenToPlayerEvents",
            value: function listenToPlayerEvents() {
                var _this = this;
                this.session.onAudioTrackWillChange(function(trackId) {
                    _this.isAudioTrackChanging = true;
                    _this.audioTrackChangeWorkaroundTimeoutId = setTimeout(function() {
                        _this.audioTrackChangeWorkaroundTimeoutId = null;
                        _this.isAudioTrackChanging = false;
                        _this.isAudioTrackBuffering = false;
                    }, AudioTrackChangeWorkaround.AUDIO_TRACK_CHANGE_WORKAROUND_TIMEOUT_DURATION);
                });
            }
        }
    ]);
    return AudioTrackChangeWorkaround;
}();
_define_property(AudioTrackChangeWorkaround, "AUDIO_TRACK_CHANGE_WORKAROUND_TIMEOUT_DURATION", 500);

//# sourceMappingURL=audio-track-change-workaround.js.map